<template>
  <div class="main">
    <topImg img="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/IndexAndPlans/plans/banner.png" title='5G+XR 解决方案' desc='格如灵科技成功助力20+行业，服务全球1000+院校'></topImg>
    <div class="content">
      <div class="list">
        <div class="example"  v-for="item in list" :key="item">
            <img v-lazy="item.setting.imageurl" :key="item.setting.imageurl" alt="" srcset="">
            <div class="title">{{item.name}}</div>
            <div class="line"></div>
            <div class="desc">{{ item.setting.alt }}</div>
            <div class="model">
              <div class="title">{{item.name}}</div>
              <div class="line"></div>
              <div class="desc">{{ item.setting.alt }}</div>
              <div class="detail" @click="go(item.setting.linkurl)">详情</div>
            </div>
        </div>
      </div>
      <!-- <div
        class="pagination"
        v-if="list.length > 0"
        id="isPCF">
        <el-pagination
          :background="true"
          layout="prev, pager, next"
          :current-page.sync='currentPage'
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="total">
        </el-pagination>
      </div>
      <van-pagination id="isMobileF" class="paginationMobile" @change='handleCurrentChange'  v-model="currentPage" :total-items="total" items-per-page='10' /> -->
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Pagination } from 'vant';
import { planList } from '@/services/api'

Vue.use(Pagination);

export default {
  data() {
    return {
      tabSelected: 0,
      total: 0,
      currentPage: 1,
      //   pageTotal: 0,
      pageSize: 12,
      list: []
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    tabChange(tab) {
      this.tabSwlected = tab.index
      this.getData()
    },
    getData() {
      let data = {
        page: this.currentPage,
        status: 0
      }
      planList(data).then(res => {
        console.log(res)
        this.list = res.data.list.jiejue_fangan
      })
    },
    go(id) {
      this.$router.push({
        path: '/plan',
        query: {
          id
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  .content{
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 100px;
    .list{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 60px;
      .example:nth-child(3n){
        margin-right: 0;
      }
      .example{
        width: 380px;
        height: 400px;
        border-radius: 19px;
        overflow: hidden;
        position: relative;
        margin-bottom: 30px;
        margin-right: 30px;
        img{
          width: 100%;
          height: 263px;
          margin-bottom: 21px;
        }
        .title{
          padding: 0 29px;
          font-size: 22px;
          font-weight: bold;
        }
        .line{
          width: 27px;
          height: 4px;
          border-radius: 2px;
          background-color: #EF623D;
          margin: 10px 29px;
        }
        .desc{
          font-size: 14px;
          padding: 0 29px;
          margin-top: 6px;
          line-height: 20px;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          height: 100px;
          text-overflow: ellipsis;
        }
        .model{
          width: 100%;
          height: 243px;
          position: absolute;
          bottom: 0;
          z-index: 2;
          background: linear-gradient(180deg, rgba(246, 140, 68, 0.8) 0%, rgba(233,100,61, 99%) 30%, #EF623D 100%);
          box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
          border-radius: 19px;
          opacity: 0;
          transition: all .3s;
          .line{
            background-color: #fff;
          }
          .title{
            color: #fff;
            padding: 0 29px;
            margin-top: 25px;
            font-size: 22px;
            font-weight: bold;
          }
          .desc{
            color: #fff;
            margin-top: 4px;
          }
          .detail{
            width: 86px;
            height: 32px;
            font-size: 12px;
            margin: 12px 29px;
            padding-top: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 16px;
            color: #fff;
            border: 1px solid #fff;
            cursor: pointer;
          }
        }
      }
      .example:hover .model{
        opacity: 1;
      }
    }
    .pagination{
      display: flex;
      // justify-content: space-between;
      justify-content: center;
      align-items: center;
      margin-top: 33px;
      padding-bottom: 100px;
      .desc{
        span{
          color: #666666;
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
        }
        span:nth-child(2){
          color: #f27529;
        }
      }
      /deep/ .el-pager li.active {
          color: #f27529;
          cursor: default;
      }
      /deep/ .el-pager li:hover {
          color: #f27529;
      }
    }
  }
}
@media (max-width: 1000px) {
  .main {
    .content {
      width: 100%;
      padding: 0 48px 80px;
      box-sizing: border-box;
      .list {
        margin-top: 40px;
        .example {
          width: 100%;
          height: auto;
          margin-right: 0;
          margin-bottom: 40px;
          border-radius: 16px;
          img {
            height: 300px;
            margin-bottom: 16px;
          }
          .title {
            font-size: 28px;
            padding: 0 24px;
          }
          .line {
            margin: 10px 24px;
          }
          .desc {
            font-size: 24px;
            padding: 0 24px;
            height: auto;
            -webkit-line-clamp: 2;
          }
          .model {
            display: none;
          }
        }
        .example:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
